// ==== Botón WhatsApp en drawer + cart page (fix doble pestaña móvil) ====
(function () {
  // PON tu número en formato internacional sin "+":
  var PHONE = '573189727577';

  function cop(n){
    try { return n.toLocaleString('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}); }
    catch(e){ return '$' + Math.round(n); }
  }

  async function buildMessage(){
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();
    const lines = cart.items.map(function(i){
      var line = (i.final_line_price/100);
      var variant = i.variant_title ? ' ('+i.variant_title+')' : '';
      return '• ' + i.quantity + ' x ' + i.product_title + variant + ' — ' + cop(line);
    }).join('\n');
    var total = cop(cart.total_price/100);
    return 'Hola 👋 Quiero pagar este pedido por WhatsApp:\n'
         + lines + '\n— Total: ' + total + '\n\n'
         + 'Datos de envío:\nNombre:\nCiudad:\nDirección:\nTeléfono:';
  }

  // --- anti doble-disparo ---
  var opening = false;
  function startOpenGuard(){
    if (opening) return false;
    opening = true;
    setTimeout(function(){ opening = false; }, 1200); // ventana de protección
    return true;
  }

  // Abrimos ventana "en el gesto" y luego redirigimos (anti-popup-blocker)
  async function openWAImmediate(e){
    if(e) e.preventDefault();
    if(!PHONE){ alert('Falta configurar el número de WhatsApp.'); return; }

    // evita abrir 2 veces por click + pointerup
    if (!startOpenGuard()) return;

    // Abrir ventana/tap objetivo inmediatamente (gesto del usuario)
    var preWin = null;
    try { preWin = window.open('about:blank', '_blank'); } catch(_){ /* ignore */ }

    try{
      var msg = await buildMessage();
      var url = 'https://api.whatsapp.com/send?phone=' + PHONE + '&text=' + encodeURIComponent(msg);

      if (preWin && !preWin.closed) {
        preWin.location = url;
        preWin.focus();
      } else {
        window.location.href = url; // fallback si bloquean popup
      }
    }catch(err){
      console.warn('WA order error', err);
      if (preWin && !preWin.closed) preWin.close();
      alert('No pudimos abrir WhatsApp. Intenta de nuevo.');
    }
  }

  // --- CART PAGE: crear botón exactamente DEBAJO del de Pagar ---
  function ensureCartPageButton(){
    var checkoutBtn = document.querySelector('.cart-page__summary button[name="checkout"]');
    if(!checkoutBtn) return;

    if (checkoutBtn.parentElement.querySelector('.wa-cart-button--page')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--primary button--full wa-cart-button--page';
    btn.style.marginTop = '12px';
    btn.textContent = 'Comprar por WhatsApp';

    // Un solo tipo de evento según el dispositivo para evitar duplicados
    var isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    btn.addEventListener(isTouch ? 'pointerup' : 'click', openWAImmediate, { passive: false });

    checkoutBtn.insertAdjacentElement('afterend', btn);
  }

  // --- DRAWER: enlazar clicks del snippet ---
  function wireDrawerButtons(){
    document.querySelectorAll('.wa-cart-button').forEach(function(btn){
      if (btn.__waBound) return;
      var isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      btn.addEventListener(isTouch ? 'pointerup' : 'click', openWAImmediate, { passive: false });
      btn.__waBound = true;
    });
  }

  // Observadores para re-render
  var moSummary, moDrawer, tick;
  function observeSummary(){
    var summary = document.querySelector('.cart-page__summary');
    if (!summary || moSummary) return;
    moSummary = new MutationObserver(function(){
      clearTimeout(tick);
      tick = setTimeout(ensureCartPageButton, 120);
    });
    moSummary.observe(summary, {childList:true, subtree:true});
  }
  function observeDrawer(){
    var drawer = document.querySelector('.cart-drawer__dialog') || document.querySelector('cart-drawer-component');
    if (!drawer || moDrawer) return;
    moDrawer = new MutationObserver(function(){ wireDrawerButtons(); });
    moDrawer.observe(drawer, {childList:true, subtree:true});
  }

  // Eventos
  document.addEventListener('DOMContentLoaded', function(){
    ensureCartPageButton(); wireDrawerButtons();
    observeSummary(); observeDrawer();
  });
  document.addEventListener('shopify:section:load', function(){
    ensureCartPageButton(); wireDrawerButtons();
    observeSummary(); observeDrawer();
  });
  document.addEventListener('cart:updated', function(){
    ensureCartPageButton(); wireDrawerButtons();
  });
  document.body.addEventListener('click', function(e){
    if(e.target.closest('button')) setTimeout(function(){
      ensureCartPageButton(); wireDrawerButtons();
    }, 300);
  });
})();

